module.exports = __webpack_public_path__ + "static/img/blue-house.6b25153.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/blue-house.jpg
// module id = hKPj
// module chunks = 0